/**
 * Convex client wiring.
 *
 * The app works without a backend: `hasConvex` is false when VITE_CONVEX_URL
 * is unset, and the UI then offers local hot-seat play instead of online rooms.
 * Set VITE_CONVEX_URL (e.g. in packages/client/.env.local) to enable rooms.
 */

import { ConvexReactClient } from "convex/react";

const url = (import.meta.env.VITE_CONVEX_URL as string | undefined) ?? "";

export const convex: ConvexReactClient | null = url ? new ConvexReactClient(url) : null;

export const hasConvex = convex !== null;

export const convexUrl = url;
